import { AbstractLifeCycle } from '@datadog/browser-core';
export var LifeCycle = (AbstractLifeCycle);
